import { SuccessResult } from './SuccessResult';
import { FailureResult } from './FailureResult';
import type { ExecuteResponse } from '../../types';

interface ExecutionResultProps {
  result: ExecuteResponse;
  onRetry: () => void;
  onStartOver: () => void;
  canRetry: boolean;
}

export function ExecutionResult({
  result,
  onRetry,
  onStartOver,
  canRetry,
}: ExecutionResultProps) {
  // Backend returns 'status' not 'success'
  if (result.status && result.counts) {
    return (
      <SuccessResult
        counts={result.counts}
        credentials={result.credentials}
        onNewOnboarding={onStartOver}
        dryRun={result.dryRun}
      />
    );
  }

  return (
    <FailureResult
      error={result.error || { message: result.msg || 'An unknown error occurred' }}
      rollbackStatus={result.rollbackStatus}
      partiallyCreated={result.partiallyCreated}
      onRetry={onRetry}
      onStartOver={onStartOver}
      canRetry={canRetry}
    />
  );
}
